import * as Sentry from '@sentry/gatsby';
import { sentryQabConfig } from '@agria/utils/src/sentryConfig';

Sentry.init({
  ...sentryQabConfig,
  dsn: 'https://dbf02c93df4a3d3a91def7749f9e3dd9@o207017.ingest.sentry.io/4506031223275520',
});
